/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import Vehicle from "./Vehicle/Vehicle";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const Vehicles = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasVehicles: pcs.hasVehicles,
    vehicles: pcs.vehicles,
  };

  const { values, handleChange, handleSubmit, touchedValues, handleBlur, errors } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const empty = {
      make: "",
      manufactured: "",
      purchased: "",
      ownership: "",
      mileage: "",
      value: "",
    };

    const vehicles = values.vehicles || [];
    if (vehicles.length >= 3) {
      return;
    }

    vehicles.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "vehicles",
        value: vehicles,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "vehicles",
          value: _.slice(values.vehicles, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Kraftfahrzeuge</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie ein Kraftfahrzeug (Auto, Motorrad, etc.)?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Kraftfahrzeug"}
              name={"hasVehicles"}
              value={formValue(values, "hasVehicles")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {formValue(values, "hasVehicles") === "yes" && (
            <>
              {_.map(values.vehicles, (vehicle, key) => (
                <React.Fragment key={key}>
                  <Vehicle path={`vehicles[${key}]`} vehicle={vehicle} handleChange={handleChange} />
                  {parseInt(key) < 2 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie ein weiteres Kraftfahrzeug?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weiteres Kraftfahrzeug?"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "vehicles").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default Vehicles;
